<app-vwo-capturer></app-vwo-capturer>
<app-menu></app-menu>
<router-outlet class="add-nav-margin"></router-outlet>
<app-footer></app-footer>
